import type React from 'react';

import useOrderingExperience from '@/hooks/useOrderingExperience';

const MarketplaceExperience: React.FC<React.PropsWithChildren<unknown>> = ({children}) => {
  const {isMarketplace} = useOrderingExperience();

  return isMarketplace ? <>{children}</> : null;
};

export default MarketplaceExperience;
